var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.32069 5.63769C1.31799 4.23756 1.31665 3.53749 1.5881 3.00219C1.82688 2.53133 2.20859 2.14814 2.67853 1.90755C3.21279 1.63404 3.91285 1.63269 5.31298 1.63L12.313 1.61652C13.7131 1.61382 14.4132 1.61248 14.9485 1.88393C15.4193 2.12271 15.8025 2.50442 16.0431 2.97437C16.3166 3.50862 16.318 4.20868 16.3207 5.60881L16.3341 12.6088C16.3368 14.0089 16.3382 14.709 16.0667 15.2443C15.8279 15.7152 15.4462 16.0983 14.9763 16.3389C14.442 16.6124 13.742 16.6138 12.3418 16.6165L5.34186 16.63C3.94173 16.6327 3.24166 16.634 2.70636 16.3626C2.23549 16.1238 1.85231 15.7421 1.61172 15.2721C1.33821 14.7379 1.33686 14.0378 1.33416 12.6377L1.32069 5.63769Z",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.42ade290d21db657478b6040b479569f.svg";
export { ForwardRef as ReactComponent };